module.exports = __webpack_public_path__ + "img/u-key.dd802dfb.png";